import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Body1Strong,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { TSparseSubmission } from '../../types/submissions.types';
import SubmissionTableItem from './SubmissionTableItem';
import { TJurisdictionMap } from '@modules/items';

const useStyles = makeStyles({
  tableContainer: {
    overflow: 'hidden',
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow2,
  },
  table: {
    borderSpacing: '0 10px',
    '& tr > :first-child': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& tr > :last-child': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    '& tr': {
      height: '48px',
    },
  },
  headerPadding: {
    padding: `${tokens.spacingHorizontalS} ${tokens.spacingVerticalL}`,
  },
  tableBody: {
    '& > :last-child': {
      borderBottom: 'none',
    },
  },
});

type TProps = {
  submissions: TSparseSubmission[];
  jurisdictionsMap: TJurisdictionMap;
};

const SubmissionsTable = ({ submissions, jurisdictionsMap }: TProps) => {
  const classes = useStyles();

  return (
    <div className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableHeader>
          <TableRow>
            <TableHeaderCell style={{ width: '250px' }} className={classes.headerPadding}>
              <Body1Strong>Submission title</Body1Strong>
            </TableHeaderCell>

            <TableHeaderCell style={{ width: '150px' }}>
              <Body1Strong>Jurisdiction</Body1Strong>
            </TableHeaderCell>

            <TableHeaderCell style={{ width: '120px' }}>
              <Body1Strong>Status</Body1Strong>
            </TableHeaderCell>

            <TableHeaderCell style={{ width: '120px' }}>
              <Body1Strong>Progress</Body1Strong>
            </TableHeaderCell>

            <TableHeaderCell style={{ width: '120px' }}>
              <Body1Strong>Due date</Body1Strong>
            </TableHeaderCell>

            <TableHeaderCell style={{ width: '120px' }}>
              <Body1Strong>Leads</Body1Strong>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody className={classes.tableBody}>
          {submissions.map((submission) => (
            <SubmissionTableItem key={submission._id} submission={submission} jurisdictionsMap={jurisdictionsMap} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SubmissionsTable;
